
function format(address) {
  if (address.apartment) {
    return `${address.street}, ${address.apartment}, ${address.city}, ${address.state} ${address.zip_code}`
  }
  else {
    return `${address.street}, ${address.city}, ${address.state} ${address.zip_code}`
  }
}

export default {
  format
}
